import { gql } from "@apollo/client";

const SYNC_WHATSAPP_TEMPLATES = gql`
  mutation syncWhatsAppTemplates($pageId: String!) {
    syncWhatsAppTemplates(pageId: $pageId) {
      success
      error
      syncedCount
      templates {
        id
        pageId
        wabaId
        metaTemplateId
        name
        language
        category
        status
        qualityScore
        bodyText
        headerType
        headerText
        footerText
        buttons
        placeholderCount
        lastSyncedAt
      }
    }
  }
`;

export default SYNC_WHATSAPP_TEMPLATES;
